module.exports = __webpack_public_path__ + "img/energy.d5b3efc.svg";